export interface ProData {
  partner_urn: string;
  contact_name: string;
  company_name: string;
  account_key: string;
  match_key: string;
}

export function initialProData(): ProData {
  return {
    partner_urn: '',
    contact_name: '',
    company_name: '',
    account_key: '',
    match_key: ''
  };
}
